import type { RiskInsightsSiteRow } from 'src/app/portfolio/state/api/riskInsightsSitesQuery';
import { formatAssessmentDate } from './formatAssessmentDate';

const HEADERS = [
    'Site',
    'Country',
    'Primary Activity',
    'Physical Nature Risk',
    'Operational Dependencies',
    'Impacts on Nature',
    'State of Nature',
    'Assessment Date',
] as const;

const formatScore = (value: number | null | undefined): string => {
    if (value === null || value === undefined) {
        return '';
    }
    return value.toFixed(2);
};

const escapeCell = (value: string): string => {
    if (/[",\n]/.test(value)) {
        return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
};

const itemToRow = (item: RiskInsightsSiteRow): string[] => [
    item.name,
    item.geography?.countryName ?? '',
    item.activity?.isicDetail.description ?? '',
    formatScore(item.riskSummary?.physicalNatureRisk),
    formatScore(item.riskSummary?.operationalDependencies),
    formatScore(item.riskSummary?.impactsOnNature),
    formatScore(item.riskSummary?.stateOfNature),
    item.riskSummary ? formatAssessmentDate(item.riskSummary.assessmentDate) : '',
];

export const buildSiteListCsv = (items: RiskInsightsSiteRow[]): string => {
    const rows = [HEADERS.join(','), ...items.map(item => itemToRow(item).map(escapeCell).join(','))];
    return rows.join('\n');
};
